/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CategoryMoving: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M21.6025 3.00488C22.1067 3.05621 22.5 3.48232 22.5 4V8C22.5 8.55228 22.0523 9 21.5 9H21V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9H2.5C1.94772 9 1.5 8.55228 1.5 8V4L1.50488 3.89746C1.55621 3.39333 1.98232 3 2.5 3H21.5L21.6025 3.00488ZM5 20H19V9H5V20ZM14 11.5C14.5523 11.5 15 11.9477 15 12.5C15 13.0523 14.5523 13.5 14 13.5H10C9.44772 13.5 9 13.0523 9 12.5C9 11.9477 9.44772 11.5 10 11.5H14ZM3.5 7H20.5V5H3.5V7Z'
      fill='currentColor'
    />
  </React.Fragment>
)
